import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LogRocket from "logrocket";

// Replaces LogRocket's anonymous session label with the logged-in user's
// name and email. Auth0's `sub` is used as the stable user id.
export const LogRocketIdentify = () => {
  const { isAuthenticated, user } = useAuth0();

  React.useEffect(() => {
    if (!isAuthenticated || !user?.sub) {
      return;
    }
    LogRocket.identify(user.sub, {
      name: user.name || "User",
      email: user.email || "email",
    });
  }, [isAuthenticated, user?.sub, user?.name, user?.email]);

  return null;
};
